import * as prismicH from '@prismicio/helpers';
import NextImage from 'next/image';
import Link from 'next/link';
import { Bounded } from './Bounded';
import PrismicLink from './PrismicLink';
import { SliceZone, PrismicRichText } from '@prismicio/react';
import { components } from '../slices';

const SOCIAL = {
  // twitter: 'https://twitter.com/Questionmark_NL',
  // facebook: 'https://facebook.com/questionmarkfoundation',
  linkedin: 'https://www.linkedin.com/company/foundation-questionmark'
};

export const Footer = ({ ctas, settings, text, items = [] }) => {
  const year = new Date().getFullYear();
  const [nav1, nav2, nav3, nav4] = items;
  return (
    <>
      <SliceZone slices={ctas} components={components} />
      <Bounded as="footer" className="border-bottom-0">
        <div className="py-5">
          <div className="row">
            <div className="col-lg-2">
              <FooterNavGroup nav={nav1} />
            </div>
            <div className="col-lg-2">
              <FooterNavGroup nav={nav2} />
            </div>
            <div className="col-lg-2">
              <FooterNavGroup nav={nav3} />
            </div>
            <div className="col-lg-6">
              <NextImage
                src="/images/questionmark-logo.svg"
                alt="Questionmark"
                height={38}
                width={256}
                className="mb-4"
              />
              <PrismicRichText field={text} />
              <FooterNavGroup nav={nav4} />
              <div className="mt-4 d-flex flex-wrap gap-2 align-items-start">
                <NextImage
                  src="/images/social/anbi-wide.svg"
                  alt="ANBI"
                  width={80}
                  height={42}
                />
                {Object.keys(SOCIAL).map((key) => (
                  <Link
                    href={SOCIAL[key]}
                    target="_blank"
                    key={key}
                    className="btn btn-outline-primary">
                    <NextImage
                      src={`/images/social/${key}.svg`}
                      alt={key}
                      width={25}
                      height={25}
                    />
                  </Link>
                ))}
                <Link href="/donate" className="btn btn-primary">
                  <NextImage
                    src="/images/charity-donate-bag-white.svg"
                    width={25}
                    height={25}
                    className="me-1"
                  />
                  Donate
                </Link>
                <Link href="/newsletter" className="btn btn-primary">
                  <NextImage
                    src="/images/newspaper-fold-white.svg"
                    width={25}
                    height={25}
                    className="me-2"
                  />
                  Subscribe
                </Link>
              </div>
            </div>
          </div>

          <div className="text-center small text-muted pt-4">
            Copyright &copy; {year} {prismicH.asText(settings.data.siteTitle)}
          </div>
        </div>
      </Bounded>
    </>
  );
};

function FooterNavGroup({ nav }) {
  if (!nav) return null;
  if (nav && !nav.items.length) return null;
  return (
    <div className="mb-5">
      <strong>{nav.primary.label}</strong>
      <ul className="list-unstyled">
        {nav.items.map((item) => (
          <li key={item.label} className="mt-1">
            <PrismicLink field={item.link} className="text-ship-light">
              {item.label}
            </PrismicLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
